import React, { useState } from 'react';
import { Button, Toaster } from '../common';
import type { Match } from '../../types/match';
import { ChatLines } from 'iconoir-react';
import { startDirectMessage } from '../../services/chatServices';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { routes } from '../../lib/routes';

interface AgentReviewMatchActionsProps {
  match: Match;
  onApprove?: () => Promise<void>;
  onReject?: (open: boolean) => Promise<void>;
  variant: 'horizontal' | 'vertical';
  openReviewModal?: boolean;
  setOpenReviewModal?: (open: boolean) => void;
}

const AgentReviewMatchActions = ({
  match,
  variant,
}: AgentReviewMatchActionsProps) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleStartChat = async (targetUserId: string) => {
    setIsLoading(true);
    try {
      const conversationId = await startDirectMessage(targetUserId, match.id);
      if (!conversationId) {
        toast.custom(t => (
          <Toaster message='Failed to start chat' type='error' id={t.id} />
        ));
        return;
      }
      navigate(`${routes.chat}?channel=${conversationId}`);
    } catch {
      toast.custom(t => (
        <Toaster message='Failed to start chat' type='error' id={t.id} />
      ));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`flex flex-col gap-2 my-1 ${variant === 'horizontal' ? 'justify-end' : 'items-center'}`}
    >
      {/* Jun-18 (a user V1 test, P4 follow-up): removed the "AI Conversation"
          button that navigated to /ai-conversation. AI-to-AI conversation was
          decided out of scope; this was its last user-facing entry point on
          pursued/passed match cards. Direct human messaging stays. */}
      <Button
        size='sm'
        color='dark'
        isLoading={isLoading}
        onClick={() => handleStartChat(match.other_user.id)}
        className={`${variant === 'horizontal' ? 'w-full md:w-fit' : 'w-full'}`}
      >
        <ChatLines className='w-5 h-5' /> Send Message
      </Button>
    </div>
  );
};

export default AgentReviewMatchActions;
